import { useState, useEffect } from 'react'

export default function useStopwatch({ id, seconds = 15, resolution = 1000, alarmThreshold, onAlarm }) {
  const [ timeRemaining, setTimeRemaining ] = useState(seconds)
  const [ alarmQueued, alarm ] = useState(false)

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining(x => {
        if (x > 0) {
          return x - (resolution / 1000)
        }
        else {
          clearInterval(timer)
          return 0;
        }
      })
    }, resolution)

    return () => {
      setTimeRemaining(seconds)
      alarm(false)
      clearInterval(timer)
    }
  }, [ id, resolution ])

  useEffect(() => {
    if (!alarmQueued && timeRemaining <= alarmThreshold) {
      alarm(true)
    }
  }, [ alarmQueued, timeRemaining, alarmThreshold ])

  useEffect(() => {
    if (alarmQueued && onAlarm) {
      onAlarm()
    }
  }, [ alarmQueued, onAlarm ])

  return timeRemaining
}